<template>
  <Modal
      v-if="showMe"
      :config='modalConfig.noticeCashIsaWarning'
      @btn1Action="handleContinue()"
      @btn2Action="handleCancel()">
    <span slot='modalContent' class='font-weight-medium'
          style="display: block; margin-bottom: 30px;" data-qa="noticecashisawarning-span-98mn4">
        {{ text }}
    </span>
  </Modal>
</template>

<script>

export default {
  name: 'NoticeCashIsaWarning',
  props: {
    subtitle: String,
    text: String
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      showMe: true,
      modalConfig: {
        noticeCashIsaWarning: {
          enabled: true,
          title: this.subtitle,
          persistent: true,
          btn1Label: this.$t('noticeCashIsa.common.button.continue'),
          btn2Label: this.$t('noticeCashIsa.common.button.cancel'),
          width: 500
        }
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('onCancel')
    },
    handleContinue () {
      this.$emit('onContinue')
    }
  }
}
</script>
